import React, { useCallback } from 'react';
import Modal from '../modal/modal';
import { logout } from '../../authProvider';
import { COMMON, LOGOUT_MODAL } from '../../constants';
import './logoutmodal.css';

const CommonLogout = ({ isOpen }) => {
    const handleOk = useCallback(() => {
        logout();
    }, []);

    return (
        <>
            {/* Visually hidden live region - announces when modal opens */}
            <div aria-live="assertive" aria-atomic="true" className="sr-only">
                {isOpen && `${LOGOUT_MODAL.title}. ${LOGOUT_MODAL.message}`}
            </div>

            <Modal
                modalActive={isOpen}
                title={LOGOUT_MODAL.title}
                alert={true}
                dialogClass={'ant-modal alert-custom-modal'}
                modal_generic_btn={true}
                btnTtl={COMMON.ok}
                onYesClick={handleOk}
                hideCloseIcon={true}
                deactivateModal={handleOk}
                expandedContent={
                    <div className="common-logout__content">
                        <p className="common-logout__message">
                            {LOGOUT_MODAL.message}
                        </p>
                    </div>
                }
            />
        </>
    );
};

export default CommonLogout;
